import { render, staticRenderFns } from "./financialRegion.vue?vue&type=template&id=b5418ea0&scoped=true&"
import script from "./financialRegion.vue?vue&type=script&lang=js&"
export * from "./financialRegion.vue?vue&type=script&lang=js&"
import style0 from "./financialRegion.vue?vue&type=style&index=0&id=b5418ea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5418ea0",
  null
  
)

export default component.exports